import types from "../ActionTypes/Index";
import { Action } from "./Reducer";

/**
 * Tracks how many requests are on the wire rather than a bare on/off flag.
 *
 * The interceptors in HttpClient dispatch SHOW_LOADER per request and
 * HIDE_LOADER per settled request. With a boolean, the first response of several
 * concurrent requests cleared the indicator while the rest were still pending.
 * Counting keeps the indicator up until the last one settles.
 *
 * `loaderVisible` is kept as a derived boolean so existing consumers - such as
 * withPageConfiguration - read it exactly as before.
 */
const initialState = {
  pendingRequests: 0,
  loaderVisible: false,
};

const LoadingIndicatorReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case types.SHOW_LOADER: {
      const pendingRequests = state.pendingRequests + 1;
      return {
        ...state,
        pendingRequests,
        loaderVisible: true,
      };
    }
    case types.HIDE_LOADER: {
      // Clamped: a stray HIDE must not push the count negative and wedge the
      // indicator on for every later request.
      const pendingRequests = Math.max(0, state.pendingRequests - 1);
      return {
        ...state,
        pendingRequests,
        loaderVisible: pendingRequests > 0,
      };
    }
    case types.RESET_STORE:
      return initialState;
    default:
      return state;
  }
};

export default LoadingIndicatorReducer;
